module.exports = __webpack_public_path__ + "img/3.b8632f39.jpg";